import React, { useContext } from "react";
import { SessionContext } from "../contexts/SessionContext";

const ApiModeDropdown = () => {
  const { apiMode, setApiMode } = useContext(SessionContext);

  const handleChange = (event) => {
    setApiMode(event.target.value);
  };

  return (
    <div>
      <label htmlFor="apiMode">Select API Mode: </label>
      <select id="apiMode" value={apiMode} onChange={handleChange}>
        <option value="server">Server</option>
        <option value="local">Local</option>
      </select>
    </div>
  );
};

export default ApiModeDropdown;
